// import v3IframeStyles from '../styles/v3/v3-iframes.css';

import BaseClass from './BaseClass';
//import LiveChatRoom from './LiveChatRoom'; // TODO:  remove LiveChatRoom dependency as it's used in dropdown invitation case
import WidgetTypes from './enums/WidgetTypes';
import { getInitiatedBy } from './ChatUtilityFunctions';
import TempCache from './enums/TempCache';
import clone from './utilities/Clone';
import BrandingWidget from './enums/BrandingWidget'
import GlobalVariables from './GlobalVariables';
import getElementsByClassName from './hooks/getElementsByClassName';
import ChatMode from './hooks/ChatMode';
import ManageFocusOnKeyEvents from './hooks/ManageFocusOnKeyEvents';
import TimeTracker from './hooks/TimeTracker';
import addStyleTextInIframe from './hooks/addStyleTextInIframe';
import ADACompliant from './hooks/ADACompliant';
import logClickEventOnGA from './hooks/logClickEventOnGA';
import log from './hooks/log';
import ProfileTextType from './hooks/ProfileTextType';
import { ChatSize, ChatType, InvitationAction, InvitationDisplayMode, InvitationTabDirection, InviteSize, LogLevel, MobileDisplayMode, Position, SkinInviteType, SkinRegionType } from './enums/Enum';
import parseTemplate from './hooks/parseTemplate';
import Branding from './hooks/Branding';
import getViewport from './hooks/getViewport';
import getFixedTop from './hooks/getFixedTop';
import sendChatAndLeadAnalytics from './hooks/sendChatAndLeadAnalytics';
import TempStorageCache from './hooks/TempStorageCache';
import Browser from './hooks/Browser';
import ServerLog from './hooks/ServerLog';
import getScript from './hooks/getScript';
import throttleByFunctionName from './hooks/throttleByFunctionName';
import SetADACompliantAttributes from './hooks/SetADACompliantAttributes';
import googleAnalyticsObjectInit from './hooks/googleAnalyticsObjectInit';
import getGaClientId from './hooks/getGaClientId';
import { writeTrafficSourcesLogic } from '../trackingcookies';
import Behaviors from './WidgetBase';
import getQueryStringValue from './hooks/getQueryStringValue';
import BehaviorTypes from './hooks/BehaviorTypes';
import getStyleForIframe from './hooks/getStyleForIframe';
import observe from './hooks/observe';
import Cookies from './hooks/Cookies';
import WidgetStates from './hooks/WidgetStates';
import getCookieValue from './hooks/getCookieValue';
import getStorageAPIValue from './hooks/getStorageAPIValue';
import storageAPIExists from './hooks/storageAPIExists';
import isEscapeKey from './hooks/isEscapeKey';
import isTabKey from './hooks/isTabKey';
import isAcceptKey from './hooks/isAcceptKey';
import showElement from './hooks/showElement';
import logIt from '../../logIt';

export class BaseWidget extends BaseClass {
    /** BASIC INIT LIFECYCLE METHODS * */
    constructor(options) {
        super(options); // Zee: this will set global variable in BaseClass
        const me = this;
        // important: adjust DOM object based on options.iframeId
        if (options.iframeId) {
            const iFrame = document.getElementById(options.iframeId);
            this.DOM = (iFrame.contentWindow || iFrame.contentDocument).document;
            this.iFrameWindow = iFrame.contentWindow || iFrame.contentDocument;
        }
        this.container = this.getContainer();
        this.options = Object.assign(
            {
                targetElementId: null,
                chatSize: ChatSize.Small,
                overrideHandlerId: 0,
                invitationDisplayMode: InvitationDisplayMode.Drop,
                containerId: 'apexchat_invitation_container_wrapper',
                maskId: 'apexchat_invitation_mask',
                inProgressContainerId: 'apexchat_invitation_container_inprogress_wrapper',
                minimizedContainerId: 'apexchat_invitation_container_minimized_wrapper',
                exitPopupRegionEditorContainerId:
                    'apexchat_invitation_container_exit_popup_region_editor_wrapper',
                callToActionId: 'apexchat_invitation_calltoaction',
                mobileDOM_MinimizeInvitation: 'apexchat_chevronstyle_dom_invitation_minimize',
                mobileDOM_Chevron: 'apexchat_chevronstyle_arrow_direction',
                mobileDOM_ChevronInMinimizedContainer: 'apexchat_chevronstyle_min_arrow_direction',
                chevronStyle_MinimizeInvitation: 'apexchat_chevronstyle_dom_min_minimize',
                chevronStyle_AgentImage: 'apexchat_chevronstyle_dom_agent_img',
                minimizedCallToActionId: 'apexchat_minimized_invitation_calltoaction',
                closeButtonId: 'apexchat_invitation_close',
                altCloseButtonId: 'apexchat_invitation_close_alt',
                tabHeaderId: 'livechat_invitation_tab',
                exitPopupContainerId: 'apexchat_exit_popup_chat_wrapper',
                exitPopupMinimizedContainerId:
                    'apexchat_invitation_container_exit_popup_minimized_wrapper',
                initialLoadTimeout: 500,
                subsequentLoadTimeout: 0,
                animationTime: 0,
                handlerImageUrl: '/contents/images/agents/amanda.jpg',
                agentName: 'Amanda',
                agentAliasId: 0,
                operatorId: 0,
                defaultOperatorId: -1,
                visitorId: 0,
                profileId: 0,
                highlightColor: '#fff118',
                // if true, when the close icon is clicked, the entire thing will hide, and no mimized version will be shown
                hideOnClose: false,
                alwaysShowMinimizedInviteInSecondaryLocation: false,
                // if true, when the close icon is clicked and "hideOnClose" is true, the invitation will not show again until the session runs out
                maintainHiddenState: false,
                // if true, when the close icon is clicked, the minimized version will be shown from then on
                maintainMinimizedState: false,
                skinInviteType: SkinInviteType.Standard,
                invitationTabTextTemplate: 'Live Chat',
                invitationMinimizedTabTextTemplate: 'Live Chat',
                invitationInProgressTabTextTemplate: 'Live Chat',
                invitationTextTemplate: "Hi! My name's <#=agentName#>. Can I help you?",
                invitationMinimizedTextTemplate: 'Chat with <#=agentName#>',
                invitationInProgressTextTemplate: 'Chatting with <#=agentName#>',
                invitationActionTextTemplate: 'Start Chat',
                invitationActionVideoTextTemplate: 'Video Chat',
                invitationVideoActionText: parseTemplate(
                    this.invitationVideoActionTextTemplate,
                    me.options
                ),
                invitationMinimizedActionTextTemplate: 'Start Chat',
                invitationInProgressActionTextTemplate: 'Resume Chat',
                invitationCloseTextTemplate: '',
                invitationWidgetStyle: '',
                invitationWidgetStyleQuirks: '',
                invitationWidgetStyleIE6: '',
                invitationWidgetStyleCustom: '',
                invitationWidgetTemplate: '',
                invitationWidgetTemplateMinimized: '',
                invitationWidgetTemplateInProgress: '',
                poweredBy:
                    'Powered by <a href="http://www.apexchat.com/" target="_blank">ApexChat</a>',
                chatMode: ChatMode.Windowed,
                position: Position.Right,
                secondaryPosition: Position.Right,
                invitationHideShowTabEnabled: false,
                invitationTabDirection: InvitationTabDirection.Down,
                invitationShowTabDuration: 1000,
                wiggleEnabled: false,
                wiggleInterval: 10000,
                rememberShownState: true,
                preloadEnabled: false,
                fixFlash: false,
                isMobile: false,
                mobileDisplayMode: MobileDisplayMode.Default,
                frameBuster: false,
                frameBusterMessage: '',
                invitationMask: false,
                language: getQueryStringValue('language') || 'eng',
                enableChatWindowCloseWarning: false,
                chatbar: null,
                reShowIntervalMinutes: 0,
                smsEnabled: false,
                smsSubject: 'I need...',
                smsNumber: '9999999999',
                applyMobileViewport: false
            },
            options || {}
        );
        this.widget = options.widget;
        this.draggables = options.draggables; // a new property to keep custom dragable areas/elements in the form of css selectors
        this.initiatedBy = getInitiatedBy(this.widget);
        // this.query = this.getQueryString(false, true, this.language, this.interceptorResults);

        this.behaviors = [];
        this.state.changeState({ toState: WidgetStates.Initialized });
    }
    ready() {
        const me = this;
        this.state.changeState({ toState: WidgetStates.Ready });
        TempStorageCache.add('WriteTrafficSourcesLogicApplied', false, true);
    }
    create() {
        const me = this;
        if (me.options.styleName) {
            console.log(`domain ${GlobalVariables.CdnBaseUrl} Loading ${me.options.styleName}.css`);
            getStyleForIframe(
                `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/${me.options.styleName}.css?ver=${env.BUILD_HASH}`,
                'apexchat_Iframe_css',
                undefined, me.DOM
            );
        }

        me.state.changeState({ toState: WidgetStates.Created });
        const isWriteTrafficSourcesLogicApplied = TempStorageCache.get(
            'WriteTrafficSourcesLogicApplied'
        );
        if (me.isInvitationType() && isWriteTrafficSourcesLogicApplied == 'false') {
            // ref. Chat-4318
            // while browsing within the domain, no need to change the cookie
            if (document.referrer.split('/')[2] != document.domain) {
                const previousSessionCookie = getCookieValue(
                    TempCache.VISITOR_TRACKING_COOKIE
                );
                // over write the cookie only if paid search info was missing from before
                // JIRA 4044 - In case of version #1 we dont load trackingcookies.js in which writeTrafficSourceLogic Function is written.
                // checking function before calling.
                if (
                    writeTrafficSourcesLogic &&
                    (typeof previousSessionCookie === 'undefined' ||
                        (previousSessionCookie &&
                            previousSessionCookie.indexOf('overwritetrafficsource=true') > -1))
                ) {
                    writeTrafficSourcesLogic(TempCache.VISITOR_TRACKING_COOKIE);
                    TempStorageCache.add('WriteTrafficSourcesLogicApplied', true, true);
                }
            }
        }
        // Ref. CHAT-4659, CHAT-4959, we need to initialize ans listen for incoming messages for Main/RD inv
        if (me.options.widget == WidgetTypes.DropDown) {
            if (me.isActiveChatMinimizedOnPageReload()) {
                logIt(
                    'websync connected in case of an active chat refreshed in min state...'
                );
                if (me.room) {
                    // already connected? exit to avoid double init
                    return;
                }
                import(/* webpackChunkName: "liveChatRoom" */ './LiveChatRoom').then((module) => {
                    const LiveChatRoom = module.default;
                    me.room = new LiveChatRoom(
                        Object.assign(me.options, {
                            isFromInvitation: true
                        })
                    );
                    me.room.initChatRoom();
                    me.room.setChatId(
                        getCookieValue(TempCache.CHAT_ID_COOKIE),
                        getCookieValue(TempCache.CHAT_TOKEN_COOKIE)
                    );
                });
            }
        }
        // addStyleTextInIframe(
        //     me.options.v3IframeStyles,
        //     'apexchat_Iframe_css',
        //     undefined,
        //     me.DOM
        // );

        if (!TempCache.isStaticButtonRegistered) {
            me.registerStaticButton();
            me.subscribe(WidgetTypes.Static + WidgetStates.Clicked, (data) => {
                me.onInvitationClick(me, me.options.language, data.chatInitiatedBy);
            });
            TempCache.isStaticButtonRegistered = true;
        }
    }
    registerStaticButton() {
        const me = this;
        const staticButton = document.getElementsByClassName('apexchat-new-static-button')[0];
        if (staticButton) {
            const chatInitiatedBy = getInitiatedBy(WidgetTypes.Static);
            observe(staticButton, 'click', () => {
                me.postMessage({
                    event: WidgetTypes.Static + WidgetStates.Clicked,
                    data: { chatInitiatedBy }
                });
            });
        }
    }
    show() {
        const me = this;
        // This changeState is generic and doesnt need any condition.
        this.state.changeState({ toState: WidgetStates.ShownNormal });
        // ADA Compliance
        // summary: CSS Class 'apexchat_ada_compliance' has no CSS Styling behind it means it won't effect on UI.
        // Its only for detecting the ADA Complianced HTML elements on which we do need to have the TAB Focus.
        // This is the Utility function which takes all HTML elements having the class 'apexchat_ada_compliance' as ARRAY, and apply the TabIndex on all of them.
        ADACompliant.push(me.DOM.getElementsByClassName('.apexchat_ada_compliance')).apply();
        // ADA compliance add attribute in start chat button
        SetADACompliantAttributes(
            me.DOM,
            this.options.chatMode,
            'apexchat_ada_compliance_start_chat'
        );
    }
    /* CHAT related */
    preloadChatOptions(cb) {
        const me = this;
        let query = this.getQueryString(false, false);
        if (me.options.visitorInfoId) {
            query += `& visitorInfoId=${me.options.visitorInfoId}`;
        }
        let url;
        switch (this.options.invitationVersion) {
            case 2: // V3
                url = `${env.API_URL}/api/invitations/chats/preload?${query}`;
                break;
            case 1:
                url = `${evn.API_URL}/api/invitations/chats/preload?${query}`;
                break;
            case 0:
            default:
                url = `${evn.API_URL}api/invitations/chats/preload?${query}`;
                break;
        }
        getScript(url, () => {
            me.preLoadedOptions = ApexChat.getPreloadedChatOptions();
            ApexChat.preLoadedOptions = me.preLoadedOptions;
            if (me.preLoadedOptions) {
                // check preloaded options exist then store in local storage. CHAT-7522
                ApexChat.localStorageAPI.Store(
                    'livechat_preloaded_options',
                    JSON.stringify(me.preLoadedOptions)
                );
            }
            me.state.changeState({
                toState: WidgetStates.PreloadedChatOptions
            });
            if (cb) {
                cb();
            }
        });
    }
    execChatStartHandler(callback, queryString) {
        const me = this;
        var query = ''

        if (queryString) {
            query = queryString;
        } else {
            query = this.getQueryString(false, true, me.options.language);
        }

        // const domain = ApexChat.Utils.removeHttpProtocols(me.options.domain);
        let url = `${GlobalVariables.LiveChatServiceUrl}Handlers/ChatStartHandler.ashx?initiatedBy=${me.initiatedBy}&${query}`;
        if (me.options.visitorInfoId) {
            url += `& visitorInfoId=${me.options.visitorInfoId}`;
        }
        if (me.options.videoGreetEnabled) {
            url += '&videoGreetWatchTime=' + ApexChat.options.videoGreetWatchTime;
        }
        getScript(url, () => {
            me.chatStartOptions = ApexChatStartData;
            if (callback) {
                callback();
            }
        });
    }
    execChatStartHandlerWithThrottle(cb) {
        return throttleByFunctionName(
            this.execChatStartHandler.bind(this), 5
        );
    }
    preloadFormOptions(cb) {
        let query = this.getQueryString(false, false);
        if (this.options.chatMode == ChatMode.Windowed) {
            query = ApexChatQuery;
        }
        getScript(`${GlobalVariables.ApexChatBaseUrl}Handlers/v2/FormPreload.ashx?${query}`, () => {
            cb();
        });
    }
    preloadVisitorFormOptions(cb) {
        const query = this.getQueryString(false, false);
        const url = `${GlobalVariables.ApexChatBaseUrl}Handlers/v2/VisitorFormPreload.ashx?${query}`;
        getScript(url, () => {
            cb();
        });
    }
    reInitChat() {
        const me = this;
        const query = me.getQueryString(false, true, me.options.language);
        me.preloadChatOptions(() => {
            me.$.get(`${GlobalVariables.LiveChatServiceUrl}/Handlers/ChatStartHandler.ashx?${query}`, (data) => {
                me.chatStartOptions = ApexChatStartData;
                me.uicontroller.room = null;
                me.uicontroller.loadChatRoom();
            });
        });
    }
    /** METHODS FOR STATE MANAGEMENT * */
    getCurrentState() {
        // ZEE: this must be tested against each widget type!
        const state = this.state.getCurrentState();
        return state;
    }
    minimize() {
        this.state.changeState({
            toState: WidgetStates.ShownMinimized
        });
        showElement(this.options.parentDivId);
        showElement(
            this.DOM.getElementById(this.widget + WidgetStates.ShownMinimized)
        );
    }
    maximize() {
        this.state.changeState({
            toState: WidgetStates.ShownMaximized
        });
        showElement(this.options.parentDivId);
        showElement(
            this.DOM.getElementById(this.widget + WidgetStates.ShownMaximized)
        );
    }
    hide() {
        this.state.changeState({ toState: WidgetStates.Hidden });
    }
    popout() {
        this.state.changeState({ toState: WidgetStates.PoppedOut });
    }
    async close() {
        this.state.changeState({ toState: WidgetStates.Closed });
        const module = await import(/* webpackChunkName: "questionTypeRendererFactory" */ '../questiontypes/QuestionTypeRendererFactory')
        const QuestionTypeRendererFactory = module.default;
        new QuestionTypeRendererFactory().destroy();
    }
    /** EVENT HANDLERS * */
    onInvitationClick(e, language, chatInitiatedBy, extra) {
        const me = this;
        logClickEventOnGA();
        const isDomChatPoppedOut =
            ApexChat.WindowedChatStarted ||
            getStorageAPIValue('livechat_has_windowed_chat_started') == 'true';
        const tracker = new TimeTracker()
        tracker.start();
        var usingSmsService = false;
        // me.invokeChatInterceptor(); It is now being invoked in getQueryString function
        if (chatInitiatedBy == 'FacebookMessenger') {
            me.startFacebookChat();
        } else if (chatInitiatedBy == 'TabSMS') {
            chatInitiatedBy = 'Tab';
            me.getSmsService(chatInitiatedBy);
            usingSmsService = true;
        } else if (chatInitiatedBy == 'BarSmsContainer') {
            me.getSmsService(chatInitiatedBy);
            usingSmsService = true;
        } else if (this.options.chatMode == ChatMode.Windowed) {
            if (this.options.requestVisitorInfo) {
                this.postMessage({
                    event: me.state.widget + WidgetStates.VisitorFormClicked,
                    data: {
                        chatInitiatedBy,
                        interceptorResults: me.interceptorResults
                    }
                });
            } else {
                me.options.language = language;
                me.options.chatInitiatedBy = chatInitiatedBy;
                me.postMessage({
                    event: me.state.widget + WidgetStates.Clicked,
                    data: { chatInitiatedBy }
                }); // Must known to widget that chat has been clicked and windowed chat started.
                me.startWindowedChat(Object.assign(me.options, extra)); // extend option object with extra paramters
            }
        } else if (this.options.chatMode == ChatMode.DOM && !isDomChatPoppedOut) {
            /* Preventing DOM chat to open again if DOM chat popped out */ if (
                this.options.requestVisitorInfo
            ) {
                this.postMessage({
                    event: me.state.widget + WidgetStates.VisitorFormClicked,
                    data: {
                        chatInitiatedBy,
                        interceptorResults: me.interceptorResults
                    }
                });
            } else {
                this.postMessage({
                    event: me.state.widget + WidgetStates.Clicked,
                    data: {
                        chatInitiatedBy,
                        interceptorResults: me.interceptorResults,
                        selectedLanguage: language
                    }
                });
            }
            ApexChat.options._domStartTime = new Date().getTime();
        }
        if (usingSmsService) {
            var visitorsGoogleClientId = Cookies.get('ga_client_id');
            sendChatAndLeadAnalytics(ApexChat.options.companyTrackingSettings, true, visitorsGoogleClientId);
        }
        if (isDomChatPoppedOut) {
            /* To refocus windowed chat when user click again on invitation icon */
            me.startWindowedChat(me.options);
        }
        if (this.widget == WidgetTypes.DropDown) {
            // this.state.changeState({ toState: WidgetStates.Clicked });
        }
        // e.stopPropagation();
        // e.preventDefault();
    }
    invokeChatInterceptor() {
        const me = this;
        try {
            if (window.ChatInterceptor) {
                me.interceptorResults = window.ChatInterceptor();
                // allow end-user interception
                if (me.interceptorResults === false) {
                }
            }
        } catch (exInner) {
            // don't care
        }
    }
    startFacebookChat() {
        const me = this;
        if (this.options.isMobile) {
            // If user on Mobile Opening Facebook Messenger App
            me.DOM.getElementById('apex-hidden-anchorTag').setAttribute(
                'href',
                `https://m.me/${this.options.companyFacebookPageName}/`
            );
        } else {
            // If user on Desktop, Starting Facebook Chat with Company's facebook page.
            me.DOM.getElementById('apex-hidden-anchorTag').setAttribute(
                'href',
                `https://www.facebook.com/messages/t/${this.options.companyFacebookPageName}`
            );
        }
        me.DOM.getElementById('apex-hidden-anchorTag').click();
    }
    onVideoChatClick(e, language, chatInitiatedBy) {
        this.state.changeState({
            toState: WidgetStates.DynamicVisitorFormClicked
        });
    }
    setClickCallToAction(element, chatInitiatedBy, extra) {
        const me = this;
        const clickCallToAction = me.DOM.getElementById(element);
        let language =
            chatInitiatedBy == 'Tab'
                ? me.options.chatTab.language
                : chatInitiatedBy == 'Bar'
                    ? me.options.chatbar.language
                    : me.options.language;
        if (!language) {
            language = me.options.language;
        }
        if (clickCallToAction) {
            clickCallToAction.style.cursor = 'pointer';
            clickCallToAction.addEventListener('click',
                me.onInvitationClick.bind2(me, language, chatInitiatedBy, extra)
            ); // extra is a additional parameter we want to send on invitation click
            me.handleADA(
                clickCallToAction,
                me.onInvitationClick.bind2(me, language, chatInitiatedBy, extra)
            );
        }
    }
    openWindowed(e, v3WidgetType) {
        const me = this;
        me.postMessage({
            event: v3WidgetType + WidgetStates.Clicked,
            data: {}
        });
        me.options.chatInitiatedBy = getInitiatedBy(v3WidgetType);
        me.startWindowedChat(me.options);
    }
    bindWindowedHandler(selector, v3WidgetType) {
        const me = this;
        const element = me.DOM.querySelector(selector);
        if (!element) {
            return;
        }
        element.addEventListener('click', (e) => {
            me.openWindowed(e, v3WidgetType);
        })
        me.handleADA(element, me.openWindowed.bind2(me, v3WidgetType));
    }
    formChat(e, language, chatInitiatedBy) {
        this.state.changeState({
            toState: WidgetStates.VisitorFormClicked
        });
    }
    permutator(inputArr) {
        const results = [];
        function permute(arr, memo) {
            let cur;
            memo = memo || [];
            for (let i = 0; i < arr.length; i++) {
                cur = arr.splice(i, 1);
                if (arr.length === 0) {
                    results.push(memo.concat(cur));
                }
                permute(arr.slice(), memo.concat(cur));
                arr.splice(i, 0, cur[0]);
            }
            return results;
        }
        return permute(inputArr);
    }
    getSmsMessage(chatInitiatedBy) {
        const me = this;
        switch (chatInitiatedBy) {
            case 'Tab':
            case 'TabSmsContainer':
                return me.options.chatTab.chatTabSmsMessage;
            case 'Bar':
            case 'BarSmsContainer':
                return me.options.chatbar.chatBarSmsMessage;
            case 'SmsContainer':
                return me.options.smsSubject;
            default:
                return '';
        }
    }
    getSmsService(chatInitiatedBy) {
        const me = this;
        me.invokeChatInterceptor();
        const ChArray = me.permutator(TempCache.UNICODE_CH);
        // me.options.isMobile = true;
        // only proceed further if request coming from mobile
        if (!me.options.isMobile) {
            me.postMessage({
                event: 'apexchat_sms_form_show',
                data: { chatInitiatedBy }
            });
            return false;
        }
        // choose the data based on chatInitiatedBy
        const smsOptions = chatInitiatedBy == 'Tab' ? me.options.chatTab : me.options.chatbar;
        // only for static, chat tab sms and chat bar sms
        if (
            chatInitiatedBy == 'BarSmsContainer' ||
            chatInitiatedBy == 'SmsContainer' ||
            (chatInitiatedBy == 'Tab' && smsOptions.chatTabType == ChatType.sms) ||
            (chatInitiatedBy == 'Bar' && smsOptions.chatBarType == ChatType.sms)
        ) {
            if (!me.options.smsNumber) {
                console.warn('You have SMS enabled, but no SMS number specified!');
            }
            const separator = Browser.isiOS() ? '&' : '?';
            let url = `sms:${me.options.smsNumber}`;
            const EncodeArray = me.permutator(TempCache.UNICODE_EN);
            TempCache.UNICODE_INDEX = Math.floor(Math.random() * 120) + 1 - 1;
            const smsMessage = me.getSmsMessage(chatInitiatedBy);
            if (smsMessage) {
                //  url += separator + 'body=' + encodeURIComponent(smsMessage) + UNICODE_EN[UNICODE_INDEX].join(''); //\u00AD \u0020 \u2063 '\u00A0' '\u200B'
                url += `${separator}body=${EncodeArray[TempCache.UNICODE_INDEX].join(
                    ''
                )}${encodeURIComponent(smsMessage)}`;
            } else {
                url += `${separator}body=${EncodeArray[TempCache.UNICODE_INDEX].join('')}`;
            }
            if (!window.ga) {
                // ref. Chat-3904
                googleAnalyticsObjectInit('ga');
            }
            const gaClientId = getGaClientId(me.options.googleAnalyticsAccount, ga);
            const trafficCookie = getCookieValue('livechat_invitation_traffic_sources');
            window.location.href = url;
            const data = {
                smsCh: `\\${ChArray[TempCache.UNICODE_INDEX].join('\\')}`,
                visitationLogID:
                    me.options.visitorId || getCookieValue(TempCache.VISITOR_ID_COOKIE),
                companyId: me.options.companyId,
                initiatedBy: chatInitiatedBy,
                language: me.options.language,
                chatInterceptorValue: me.interceptorResults,
                gaClientId,
                trafficCookie: trafficCookie || ''
            };
            // ajax call to sms log call
            me.$.getJSON(`${GlobalVariables.ApexChatBaseUrl}/Handlers/SmsLogHandler.ashx`, data, (result) => {
                console.log('sms handler requested....');
            });
        }
    }
    /** METHODS RELATED TO REGION RELATED * */
    getRegionData(region) {
        const data = clone(region);
        let borderStyle = '';
        let backgroundStyle = '';
        data.fontCSS = region.textFont;
        data.width = region.width;
        data.height = region.height;
        data.zIndex = region.zIndex;
        if (region.borderWidth && region.borderWidth != '0px') {
            borderStyle = `border: solid ${region.borderWidth} ${region.borderColor ? region.borderColor : '#000000'
                }; `;
            if (region.borderRadius && region.borderRadius != '0px') {
                borderStyle += `border-radius: ${region.borderRadius}; `;
            }
            // width = width - 2 * parseInt(region.borderWidth, 10);
            // height = height - 2 * parseInt(region.borderWidth, 10);
        }
        if (region.backgroundColor) {
            backgroundStyle += `background-color: ${region.backgroundColor ? region.backgroundColor : 'inherit'
                }; `;
        }
        if (region.backgroundImage) {
            backgroundStyle += `background-image:url(${region.backgroundImage ? region.backgroundImage : 'none'
                });`;
        } else {
            // force IE to have a background image so it's clickable
            backgroundStyle +=
                'background-image:url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7); ';
        }
        data.extraCss = '';
        switch (region.type) {
            case SkinRegionType.videoChat:
            case SkinRegionType.VideoChat:
            case SkinRegionType.action:
            case SkinRegionType.Action:
                data.extraCss += 'cursor: pointer; ';
                break;
        }
        data.extraCss += borderStyle + backgroundStyle;
        return data;
    }
    // getRegionContent(region) {
    //     const content = '';
    //     let profile = this.options.profileTextsHash[region.threeLetterISOLanguageName];
    //     if (!profile) {
    //         profile = this.options;
    //     }
    //     switch (region.type) {
    //         case SkinRegionType.ProfileText:
    //         case SkinRegionType.profileText:
    //             switch (region.profileTextType) {
    //                 case ProfileTextType.poweredBy:
    //                     return profile.poweredBy;
    //                 case ProfileTextType.PoweredBy:
    //                     return profile.poweredBy;
    //                 // case ProfileTextType.disclaimer: return profile.disclaimer;
    //                 case ProfileTextType.action:
    //                     return profile.invitationActionText;
    //                 case ProfileTextType.Action:
    //                     return profile.invitationActionText;
    //                 case ProfileTextType.close:
    //                     return profile.invitationCloseText;
    //                 case ProfileTextType.Close:
    //                     return profile.invitationCloseText;
    //                 case ProfileTextType.header:
    //                     return profile.invitationHeader;
    //                 case ProfileTextType.Header:
    //                     return profile.invitationHeader;
    //                 case ProfileTextType.invitation:
    //                     return profile.invitationText;
    //                 case ProfileTextType.Invitation:
    //                     return profile.invitationText;
    //                 case ProfileTextType.tab:
    //                     return profile.invitationTabText;
    //                 case ProfileTextType.Tab:
    //                     return profile.invitationTabText;
    //                 case ProfileTextType.actionMinimized:
    //                     return profile.invitationMinimizedActionText;
    //                 case ProfileTextType.ActionMinimized:
    //                     return profile.invitationMinimizedActionText;
    //                 case ProfileTextType.invitationMinimized:
    //                     return profile.invitationMinimizedText;
    //                 case ProfileTextType.InvitationMinimized:
    //                     return profile.invitationMinimizedText;
    //                 case ProfileTextType.tabMinimized:
    //                     return profile.invitationMinimizedTabText;
    //                 case ProfileTextType.TabMinimized:
    //                     return profile.invitationMinimizedTabText;
    //                 case ProfileTextType.actionInProgress:
    //                     return profile.invitationInProgressActionText;
    //                 case ProfileTextType.ActionInProgress:
    //                     return profile.invitationInProgressActionText;
    //                 case ProfileTextType.invitationInProgress:
    //                     return profile.invitationInProgressText;
    //                 case ProfileTextType.InvitationInProgress:
    //                     return profile.invitationInProgressText;
    //                 case ProfileTextType.tabInProgress:
    //                     return profile.invitationInProgressTabText;
    //                 case ProfileTextType.TabInProgress:
    //                     return profile.invitationInProgressTabText;
    //                 case ProfileTextType.chatTitle:
    //                     return profile.chatTitle;
    //                 case ProfileTextType.ChatTitle:
    //                     return profile.chatTitle;
    //             }
    //             break;
    //         case SkinRegionType.FixedText:
    //         case SkinRegionType.fixedText:
    //             return region.fixedText;
    //         case SkinRegionType.VideoChat:
    //         case SkinRegionType.videoChat:
    //             return region.videoChat;
    //         case SkinRegionType.Action:
    //         case SkinRegionType.action:
    //             if (!region.showActionText) {
    //                 return '';
    //             }
    //             switch (region.action) {
    //                 case InvitationAction.startChat:
    //                 case InvitationAction.StartChat:
    //                     if (region.inviteSize == InviteSize.Minimized) {
    //                         return profile.invitationMinimizedActionText;
    //                     }
    //                     return profile.invitationActionText;
    //                 case InvitationAction.close:
    //                     return profile.invitationCloseText;
    //                 case InvitationAction.Close:
    //                     return profile.invitationCloseText;
    //             }
    //             break;
    //         case SkinRegionType.Image:
    //         case SkinRegionType.image:
    //             return `<img src="${region.imageUrl}" alt="Live Chat" title="Live Chat" width="${region.width}" height="${region.height}"/>`;
    //         case SkinRegionType.AgentImage:
    //         case SkinRegionType.agentImage:
    //             return `<img src="${this.options.handlerImageUrl}" alt="${this.options.agentName}" title="${this.options.agentName}" width="${region.width}" height="${region.height}"  style="border-radius:${region.borderRadius}"/>`;
    //         case SkinRegionType.OnlineIndicator: // ref. 3676
    //         case SkinRegionType.onlineIndicator:
    //             return '<div class="apexchat_image_invitation_online_indicator" title="Online.."></div>';
    //     }
    //     return content;
    // }
    /** UTIL METHODS: Deals mainly based on 'containerId' * */
    // createImage(containerId, inviteSize) {
    //     const me = this;
    //     let image;
    //     let container;
    //     let inviteTemplate = this.options.invitationImageTemplate;
    //     switch (inviteSize) {
    //         case InviteSize.full:
    //         case InviteSize.Full:
    //             image = this.options.skinFullInviteImage;
    //             this.options.shadowDepth = this.options.skinFullShadowDepth;
    //             this.options.canvasPadding = this.options.invitationCanvasPadding;
    //             this.options.width = this.options.invitationWidth
    //                 ? this.options.invitationWidth
    //                 : '400px';
    //             this.options.height = this.options.invitationHeight
    //                 ? this.options.invitationHeight
    //                 : '400px';
    //             break;
    //         case InviteSize.minimized:
    //         case InviteSize.Minimized:
    //             image = this.options.skinMinimizedInviteImage;
    //             this.options.shadowDepth = this.options.skinMinimizedShadowDepth;
    //             this.options.canvasPadding = this.options.invitationMinimizedCanvasPadding;
    //             this.options.width = this.options.invitationMinimizedWidth
    //                 ? this.options.invitationMinimizedWidth
    //                 : '400px';
    //             this.options.height = this.options.invitationMinimizedHeight
    //                 ? this.options.invitationMinimizedHeight
    //                 : '400px';
    //             break;
    //         case InviteSize.inProgress:
    //         case InviteSize.InProgress:
    //             image = this.options.skinInProgressInviteImage;
    //             this.options.shadowDepth = this.options.skinInProgressShadowDepth;
    //             this.options.canvasPadding = this.options.invitationInProgressCanvasPadding;
    //             this.options.width = this.options.invitationInProgressWidth
    //                 ? this.options.invitationInProgressWidth
    //                 : '400px';
    //             this.options.height = this.options.invitationInProgressHeight
    //                 ? this.options.invitationInProgressHeight
    //                 : '400px';
    //             break;
    //         case InviteSize.exitPopupEditor:
    //         case InviteSize.ExitPopup:
    //             image = this.options.skinExitPopupRegionEditorImage;
    //             this.options.shadowDepth = this.options.invitationExitPopupRegionEditorShadowDepth;
    //             this.options.canvasPadding = `${this.options.invitationExitPopupRegionEditorCanvasPadding} !important`;
    //             // Set template for Exit popup region editor
    //             inviteTemplate = this.options.exitPopupInvitationImageTemplate;
    //             this.options.width = this.options.invitationExitPopupMinimizedWidth
    //                 ? this.options.invitationExitPopupMinimizedWidth
    //                 : '400px';
    //             this.options.height = this.options.invitationExitPopupMinimizedHeight
    //                 ? this.options.invitationExitPopupMinimizedHeight
    //                 : '400px';
    //             break;
    //     }
    //     if (!image) {
    //         log(
    //             `No image specified for invite size ${inviteSize}`,
    //             LogLevel.Warn
    //         );
    //         return;
    //     }
    //     this.options.backgroundImageUrl = image.imageUrl;
    //     container = this.addElement(containerId, inviteTemplate);
    //     if (Browser.isIE() && Browser.isQuirksMode()) {
    //         // fix for IE in quirks not making the image links clickable
    //         container.style.zoom = 1;
    //         container.children[0].style.zoom = 1;
    //         container.style.width = this.options.width;
    //     }
    //     // good 'ol IE
    //     // this.monitorIE(container);
    //     container = container.children[0]?.children[1];
    //     // for advanced CSS
    //     if (this.options.invitationWidgetStyleCustom) {
    //         addStyleTextInIframe(
    //             this.options.invitationWidgetStyle + this.options.invitationWidgetStyleCustom,
    //             'apexchat_advance_css',
    //             undefined,
    //             me.DOM
    //         );
    //     }
    //     const root = this.DOM.getElementById(containerId);
    //     let oldDisplay;
    //     if (inviteSize === InviteSize.full || inviteSize === InviteSize.Full) {
    //         oldDisplay = root.style.display;
    //         root.style.display = 'block';
    //         let pos = this.options.position;
    //         if (this.options.isRefreshed) {
    //             pos = this.options.secondaryPosition;
    //         }
    //         // determine the position of the widget
    //         if (!this.options.startStyle) {
    //             const dims = getViewport();
    //             this.options.startStyle = this.getStartStyle(pos, root);
    //         }
    //         root.style.display = oldDisplay;
    //         // apply the initial styling
    //         for (const pro in this.options.startStyle) {
    //             if (this.options.startStyle.hasOwnProperty(pro)) {
    //                 root.style[pro] = this.options.startStyle[pro];
    //             }
    //         }
    //     } else {
    //         let prop;
    //         let style = {};
    //         oldDisplay = root.style.display;
    //         root.style.display = 'block';
    //         style = this.getStartStyle(this.options.secondaryPosition, root);
    //         root.style.display = oldDisplay;
    //         const position = this.options.secondaryPosition;
    //         if (
    //             !Browser.isIE() &&
    //             !(
    //                 position == Position.TopLeft ||
    //                 position == Position.TopMiddle ||
    //                 position == Position.TopRight
    //             )
    //         ) {
    //             style.bottom = '0px';
    //         }
    //         for (prop in style) {
    //             if (style.hasOwnProperty(prop)) {
    //                 root.style[prop] = style[prop];
    //             }
    //         }
    //     }
    //     let action = function () {
    //         console.log('ALERT! No handler found for click!');
    //     };
    //     for (let i = 0; i < this.options.skinRegions.length; i++) {
    //         if (this.options.skinRegions[i].inviteSize != inviteSize) {
    //             continue;
    //         }
    //         if (
    //             this.options.skinRegions[i].type === SkinRegionType.VideoChat &&
    //             this.options.isOpenForBusiness === false
    //         ) {
    //             continue;
    //         }
    //         const node = this.DOM.createElement('div');
    //         const region = this.options.skinRegions[i];
    //         const data = this.getRegionData(region);
    //         var subTpl;
    //         container.appendChild(node);
    //         data.content = this.getRegionContent(region);
    //         node.innerHTML = parseTemplate(
    //             this.options.invitationImageRegionTemplate,
    //             data
    //         );
    //         node.childNodes[1].tabIndex = 0;
    //         // this.applyRegionActions(node, region);
    //         if (region.type == SkinRegionType.Action) {
    //             if (region.action == InvitationAction.StartChat) {
    //                 const startChatNode = node.childNodes[1];
    //                 let chatTitle = '';
    //                 if (node.childNodes && node.childNodes.length > 1) {
    //                     // check language
    //                     if (region.threeLetterISOLanguageName == 'spa') {
    //                         chatTitle =
    //                             this.options.chatMode == ChatMode.DOM
    //                                 ? GlobalVariables.DOM_CHAT_TITLE_SPA
    //                                 : GlobalVariables.WINDOWED_CHAT_TITLE_SPA;
    //                     } else {
    //                         chatTitle =
    //                             this.options.chatMode == ChatMode.DOM
    //                                 ? GlobalVariables.DOM_CHAT_TITLE
    //                                 : GlobalVariables.WINDOWED_CHAT_TITLE;
    //                     }
    //                     // Added title in image based invitation
    //                     startChatNode.title = chatTitle;
    //                     startChatNode.setAttribute('aria-label', chatTitle);
    //                     startChatNode.setAttribute('name', 'startChat');
    //                     startChatNode.setAttribute('role', 'button');
    //                 }
    //                 action = this.options.requestVisitorInfo
    //                     ? this.formChat
    //                     : this.onInvitationClick;
    //                 me.handleADA(
    //                     me.$(node, me.DOM)[0],
    //                     action.bind2(me, region.threeLetterISOLanguageName, 'Standard')
    //                 );
    //             } else if (region.action == InvitationAction.Close) {
    //                 const closeChatNode = node.childNodes[1];
    //                 if (node.childNodes && node.childNodes.length > 1) {
    //                     // Added title in image based invitation
    //                     closeChatNode.title = 'Close Chat';
    //                     closeChatNode.setAttribute('aria-label', 'Close Chat');
    //                     closeChatNode.setAttribute('name', 'closeChat');
    //                     closeChatNode.setAttribute('role', 'button');
    //                 }
    //                 action = region.inviteSize == InviteSize.Full ? this.close : this.hide;
    //             }
    //         } else if (region.type == SkinRegionType.VideoChat) {
    //             action = this.onVideoChatClick;
    //         }
    //         me.handleADA(
    //             me.$(node, me.DOM)[0],
    //             action.bind2(this, region.threeLetterISOLanguageName, 'Standard')
    //         );
    //     }
    // }
    addElement(id, template) {
        const target = this.options.targetElementId
            ? this.DOM.getElementById(this.options.targetElementId)
            : this.DOM;
        const container = this.DOM.createElement('div');
        // add the element to the page so the following methods work
        target.body.appendChild(container);
        // hide the element and make sure it's content stays within bounds, but put it on top of everything else
        container.style.overflow = 'hidden';
        container.style.display = 'none';
        container.style.zIndex = TempCache.CONTAINER_Z_INDEX;
        // set up the container element, keeping it hidden initially
        container.id = id;
        // fixed positioning for most, absolute for IE
        container.style.position = 'fixed';
        if (Browser.isIE()) {
            container.style.position = 'absolute';
        }
        // set the content after it's been positioned
        container.innerHTML = parseTemplate(template, this.options);
        // ADA compliance add attribute in start chat button
        SetADACompliantAttributes(
            container,
            this.options.chatMode,
            'apexchat_ada_compliance_start_chat'
        );
        const ieClasses =
            (Browser.isIE7() ? ' ie7' : '') +
            (Browser.isIE8() ? ' ie8' : '') +
            (Browser.isIE9() ? ' ie9' : '');
        if (ieClasses) {
            const targets = [
                getElementsByClassName(container, 'livechat_inner')[0],
                getElementsByClassName(container, 'livechat_start_inner')[0],
                getElementsByClassName(container, 'livechat_close_alt_inner')[0]
            ];
            if (targets[0]) {
                targets[0].className += ieClasses;
            }
            if (targets[1]) {
                targets[1].className += ieClasses;
            }
            if (targets[2]) {
                targets[2].className += ieClasses;
            }
            if (Browser.isQuirksMode()) {
                if (targets[0]) {
                    targets[0].className += ' quirksForBody';
                }
                if (targets[1]) {
                    targets[1].className += ' quirksForButton';
                }
                if (targets[2]) {
                    targets[2].className += ' quirksForAltButton';
                }
            }
        }
        return container;
    }
    getStartStyle(position, container) {
        // v3 not required to set position of inner, we position only iframe
        return { right: '0px' };
    }
    monitorIE(container) {
        if (Browser.isIE()) {
            const me = this;
            // surprise! IE doesn't work properly with position:fixed
            window.setInterval(() => {
                if (me.wiggling) {
                    return;
                }
                container.style.top = getFixedTop(me.options.position, container);
            }, 50);
        }
    }
    getContainer() {
        if (!this.DOM) {
            return;
        }
        return this.DOM.getElementById(this.options.containerId);
    }
    getChatWindowDimensions() {
        const minH = 520;
        let h = 520;
        const minW = 330;
        let w = 330;
        if (this.options.chatHeight && this.options.chatWidth) {
            const viewportDimensions = getViewport();
            const screenDimensions = [
                window.outerWidth || screen.width,
                window.outerHeight || screen.height
            ];
            const diff = [
                screenDimensions[0] - viewportDimensions[0],
                screenDimensions[1] - viewportDimensions[1]
            ];
            // calculate, and throw on a little extra for various browser oddities
            // arbitrary "30" here is so if we end up with a *huge* difference in the newly calculated with vs. the actual width when the invitation
            // was designed, assume something went wrong and just fall back to a reasonable guess.
            if (diff[0] < 30 && diff[0] > 0) {
                w = this.options.chatWidth + diff[0] + 10;
            } else {
                w = this.options.chatWidth + 10;
            }
            if (diff[1] < 30 && diff[1] > 0) {
                h = this.options.chatHeight + diff[1] + 10;
            } else {
                h = this.options.chatHeight + 10;
            }
        }
        // set some minimiums
        const dims = { width: w, height: h };
        if (dims.width < minW) {
            dims.width = minW;
        }
        if (dims.height < minH) {
            dims.height = minH;
        }
        return dims;
    }
    startWindowedChat(options) {
        TempCache.WINDOWED_CHAT_STARTED = true;
        clearTimeout(TempCache.EP_SetTimeOut); // we need to remove EP timer so EP would not be appear.
        const me = this;
        if (!me.windowedChatStarted) {
            me.windowedChatStarted = true;
        } else {
            return false;
        }
        setTimeout(() => {
            me.windowedChatStarted = false;
        }, 1500);
        me.invokeChatInterceptor();
        // launch the chat in a new window; do some quick calcs to attempt to account for browser chrome
        const dims = this.getChatWindowDimensions();
        const t = 15;
        const l = 15;
        const w = 400;
        const h = 600;
        let query = this.getQueryString(
            ChatMode.Windowed,
            true,
            options.language,
            me.interceptorResults
        );
        if (options.chatId && query.indexOf('&chatId=') === -1) {
            // check if chatId not already there.
            query += `&chatId=${options.chatId}`;
        }
        const isDOM = this.options.chatMode == ChatMode.DOM;
        const target =
            this.options.requestVisitorName && !isDOM
                ? 'ChatVisitorName.aspx'
                : this.options.requestVisitorInfo && !isDOM
                    ? 'ChatVisitorInfo.aspx'
                    : 'chat';
        const isPageRefreshed = me.isPageRefreshed(); // pass is page refresh value as a parameter so it should know value on windowed as well.
        const isEPConnected = this.state.getStateValue(
            WidgetTypes.ExitPopup + WidgetStates.Created
        );
        // [ExitPopup]: FogBugs [2361] : Exit Pop up code causing console errors in chats in production (DOMException: Blocked a frame with origin..{...}..)
        // We were using window.opener and we noticed that due to Cross Origin issue some browser were blocking window.opener So, Now we are using Querystring Method
        // shouldContinueMapping and FullTextVisitorResponse send via query parameter as we need this on Windowed mode.
        const URL = `${env.API_URL + '/' + target}?initiatedBy=${options.chatInitiatedBy
            }&shouldContinueMapping=${options.shouldContinueMapping}&FullTextVisitorResponse=${options.FullTextVisitorResponse
            }&isChatActive=${me.isChatActive()}&${query}`;
        const win = window.open(
            URL,
            'ApexChatWindow',
            `height=${dims.height},width=${dims.width},top=${t},left=${l},toolbar=no` +
            `,menubar=no` +
            `,status=no` +
            `,location=no` +
            `,scrollbars=yes` +
            `,resizable=yes`
        );
        ApexChat.storageAPI.StoreTemp('livechat_has_windowed_chat_started', true);
        // safari browser in iOS does not return window.open value when popup blocker is in place.
        // We would simply return from here
        if (!win && Browser.isiOS && Browser.isSafari) {
            return;
        }
        if (!win) {
            alert(
                'You appear to have a pop-up blocker that is preventing the chat from launching. Please allow pop-ups using the notification bar at the top of the window and try again.'
            );
        }
        if (this.options.isMobile) {
            return win;
        }
        return win;
    }
    isChatInProgress() {
        return (getCookieValue(TempCache.CHAT_ID_COOKIE) || 0) > 0;
    }
    isActiveChatMinimizedOnPageReload() {
        const domState = this.state.getStateValue(WidgetTypes.DOM);
        const result =
            this.isPageRefreshed() && // is it refreshed scenario?
            domState == WidgetStates.ShownMinimized && // was dom minimized?
            this.isChatInProgress(); // was DOM/Chat started?
        return result;
    }
    isInvitationType() {
        return (
            this.options.widget == WidgetTypes.PreChat ||
            this.options.widget == WidgetTypes.DropDown ||
            this.options.widget == WidgetTypes.Bar ||
            this.options.widget == WidgetTypes.Tab
        );
    }
    // log that it was clicked
    serverLog(logInfo) {
        if (logInfo && logInfo.trackClick) {
            ServerLog.trackClick({
                companyId: logInfo.data.companyId,
                visitorId: logInfo.data.visitorId,
                clickSource: logInfo.clickSource
            });
        } else {
            ServerLog.log(logInfo.data);
        }
    }
    addBehavior(type) {
        const me = this;
        me.behaviors.push(type);
        me.include(Behaviors[type]);
    }
    showDOMFastOnClick() {
        return this.behaviors.indexOf(BehaviorTypes.FAST_DOM_UI_RENDERING) > -1;
    }
    canWidgetShowNotifications() {
        return this.behaviors.indexOf(BehaviorTypes.NOTIFICATIONS) > -1;
    }
    hasCustomClickHandlersDefined() {
        return this.behaviors.indexOf(BehaviorTypes.INVITATION_CLICKABLES) > -1;
    }
    // summay: HandleADA takes element and bind event of keyup which we need for ADA users like AcceptKey, SpaceBar, ESC key, etc.
    // What decisions we do need to call on element's keyup event.
    handleADA(element, openCallback, closeCallback) {
        const me = this;
        element?.addEventListener('keyup',
            function (e) {
                const elTrace = this.innerText || this.id || this.title;
                const targetElem = (e.target || e.srcElement).tagName;
                logIt(`handleADA:onKeyUp called on:${elTrace}`);
                // if key is Space or Enter then start chat
                if (isAcceptKey(e)) {
                    if (openCallback && typeof openCallback === 'function') {
                        logIt(`Invoke on Tab over:${targetElem}, ${elTrace}`);
                        openCallback(e);
                    }
                } else if (isEscapeKey(e)) {
                    logIt('Keydown to close emotjis');
                    if (closeCallback && typeof closeCallback === 'function') {
                        closeCallback(e);
                    }
                } else if (isTabKey(e)) {
                    logIt(`Tab over:${targetElem}, ${elTrace}`);
                    ManageFocusOnKeyEvents(me.context.querySelector(element));
                }
                e.stopPropagation();
            });
    }
    maintainPageRefreshState() {
        // to check page refresh subsequently
        if (storageAPIExists(TempCache.IS_PAGE_REFRESHED)) {
            ApexChat.storageAPI.Store(TempCache.IS_PAGE_REFRESHED, true);
        } else {
            ApexChat.storageAPI.Store(TempCache.IS_PAGE_REFRESHED, false);
            ApexChat.storageAPI.Store('livechat_has_windowed_chat_started', true);
        }
    }
    /**
    * Parse and return theme css template file
    * @param themeSettings
    * @param themeCss
    * @returns {string|string|ApexChat.Portal.ThemePanel.getSkinData.chatStyle}
    */

}
